import api from "./api";
import types from "./types";
import { request } from "api/apiSaga";
import { snackbarShow } from "app/App/actions";
import trans from "helpers/trans";
import { call, put, takeLatest } from "redux-saga/effects";
import { AnyAction } from "redux";

function* destroy(action: AnyAction): any {
    const response = yield call(request, api.destroy, action, "delete");

    if (response.status === 204) {
        yield put(
            snackbarShow({
                content: trans("event.providers.saga.content.destroy"),
            })
        );
    }
}

function* fetch(action: AnyAction) {
    yield call(request, api.fetch, action);
}

function* fetchAll(action: AnyAction) {
    yield call(request, api.fetchAll, action);
}

function* fetchDefault(action: AnyAction) {
    yield call(request, api.fetchDefault, action);
}

function* get(action: AnyAction) {
    yield call(request, api.get, action);
}

function* store(action: AnyAction): any {
    const response = yield call(request, api.store, action, "post");

    if (response.status === 201) {
        yield put(
            snackbarShow({
                content: trans("event.providers.saga.content.store"),
            })
        );
    }
}

function* storeGenerateKey(action: AnyAction): any {
    const response = yield call(request, api.storeGenerateKey, action, "post");

    if (response.status === 201) {
        yield put(
            snackbarShow({
                content: trans("event.providers.saga.content.store"),
            })
        );
    }
}

function* update(action: AnyAction): any {
    const response = yield call(request, api.update, action, "put");

    if (response.status === 200) {
        yield put(
            snackbarShow({
                content: trans("event.providers.saga.content.update"),
            })
        );
    }
}

function* updateGenerateKey(action: AnyAction): any {
    const response = yield call(request, api.updateGenerateKey, action, "put");

    if (response.status === 200) {
        yield put(
            snackbarShow({
                content: trans("event.providers.saga.content.update"),
            })
        );
    }
}

export default function* saga() {
    yield takeLatest(types.DESTROY_REQUEST, destroy);
    yield takeLatest(types.FETCH_REQUEST, fetch);
    yield takeLatest(types.FETCH_ALL_REQUEST, fetchAll);
    yield takeLatest(types.FETCH_DEFAULT_REQUEST, fetchDefault);
    yield takeLatest(types.GET_REQUEST, get);
    yield takeLatest(types.STORE_REQUEST, store);
    yield takeLatest(types.STORE_GENERATE_KEY_REQUEST, storeGenerateKey);
    yield takeLatest(types.UPDATE_REQUEST, update);
    yield takeLatest(types.UPDATE_GENERATE_KEY_REQUEST, updateGenerateKey);
}
